class l {
  value;
  isVisible;
  constructor(i, s = "") {
    this.value = s, this.isVisible = i && this.value !== "";
  }
  update(i, s) {
    this.value = s ?? this.value, this.isVisible = i;
  }
  setIsVisible(i) {
    this.isVisible = i && this.value !== null;
  }
}
export {
  l as Link
};
//# sourceMappingURL=index3.js.map
